import { Component, OnInit } from '@angular/core';

import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { ACLService, DataService, HelperService, HTTPService } from 'app/services';
import { Subscription } from 'rxjs/internal/Subscription';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-switch-corporate-dialog',
  templateUrl: './switch-corporate-dialog.component.html',
  styleUrls: ['./switch-corporate-dialog.component.scss'],
  providers: [DialogService],
})
export class SwitchCorporateDialogComponent implements OnInit {

  customerSearchResults = [];
  defaultView: any = {};
  userInfo: any;
  selectedShop: string = '';
  cId: string = '';
  isCorporate: boolean = true;
  dsSub: Subscription;
  SSOToken;
  alDashboardUrl: string = 'https://aldashboard.myautoleap.com/#!/login';
  isMarkPsDashboard: boolean;

  constructor(
    public ref: DynamicDialogRef,
    private httpService: HTTPService,
    private helperService: HelperService,
    private dataService: DataService,
    private cookieService: CookieService,
    private aclService: ACLService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit() {
    this.SSOToken = this.cookieService.getObject('alpatsso');
    this.getUserACL();
    this.isMarkPsDashboard = this.dataService.isMarkPsDashboard
  }

  getUserACL() {
    const token: any = this.cookieService.getObject('alpatsso')
    this.httpService.getUserACL(token).then(res => {
      this.userInfo = res;
      // this.userInfo = this.dialogConfig.data;
      this.cId = this.userInfo.corporate._id;
      this.isCorporate = true;
      this.userInfo.corporate.default = true;
      this.defaultView.isCorporate = true;
      this.defaultView.cId = this.cId;
    })
  }

  closeModal(){
    this.ref.close(false);
  }

  onChangeCorporate(value: string){
    this.isCorporate = true;
    this.cId = value;
    this.selectedShop = '';
    this.userInfo.corporate._id = '';
    if(this.dataService.isMarkPsDashboard){
      let url = this.alDashboardUrl;
      if(this.dataService.currentShopId && this.dataService.partnerId && this.dataService.userEmail){
        let locationId = this.dataService.currentShopId;
        locationId = locationId.substring(locationId.length - 8);
        url = `${this.alDashboardUrl}?email=${this.dataService.userEmail}&key=${this.dataService.partnerId}&locationId=${locationId}`
      }
      window.open(url, '_blank');
    }else{
      this.onSubmit();
    }
  }

  onChangeCompany(value: string, company){
    this.isCorporate = false;
    this.selectedShop = value;
    this.cId = company._id;
  }

  setDefaultView(view, event, company = undefined){
    if(view === 'corporate'){
      this.userInfo.corporate.default = true;
      this.setLocationsDefaultValue();
      this.defaultView.cId = event._id;
      this.defaultView.shopId = '';
    }else{
      if(this.defaultView.isCorporate){
        event.default = true;
        this.userInfo.corporate.default = false;
      }else{
        this.setLocationsDefaultValue(event._id)
      }
      this.defaultView.cId = company._id;
      this.defaultView.shopId = event._id;
    }
    this.defaultView.isCorporate = view === 'corporate' ? true : false;
  }

  setLocationsDefaultValue(id:string = ''){
    this.userInfo.companies.forEach(element => {
      element.shops.forEach(shop => {
        if(shop._id === id){
          shop.default = true;
        }else{
          shop.default = false;
        }
      });
    });
  }

  onSubmit() {
    const loginQuery = {
      isCorporate: this.isCorporate,
      cId: this.cId,
      shopId: this.selectedShop
    }

    // this.httpService.setDefaultShop(this.defaultView, this.SSOToken).then(data=>{
        this.httpService.siteLogin(loginQuery, this.SSOToken).then(
          (res: any) => {
            let url = '';
            if(this.isCorporate){
              this.cookieService.removeAll();
              url = `${environment.corporate_app_base_url}#/routed-company-view/${res.token}/${this.SSOToken}`
            }else{
              url = `${environment.app_base_url}/#/routed-company-view/${res.token}/${this.SSOToken}`
            }
            const win = window.open(url, '_self');
            if (!win) {
              window.location.replace(url);
            }
        });
      this.ref.close(false);
    // });
  }

}
